module.exports = __webpack_public_path__ + "img/chai_app_store.87fa97e8.png";